import api from "../utils/api";
import { verifyOTP } from "./firebase/verifyOtp";
import { sendOTP } from "./firebase/sendOtp";

// { name, address, email, password, phoneNo }
const createUser = async (idToken, dataToBE) => {
  try {
    const data = await api.post("/signup", {
      name: dataToBE.username,
      address: dataToBE.address,
      phoneNo: dataToBE.phone,
      password: dataToBE.password,
      idToken: idToken,
    });
    return data.data;
  } catch (err) {
    throw new Error(JSON.parse(err.request.response).error);
  }
};

const loginUser = async (phone, password) => {
  try {
    const data = await api.post("/signin", {
      myUser: phone,
      password,
    });
    return data.data;
  } catch (err) {
    throw err;
  }
};

const sendOtpSignup = async (data, mobile, mode = "signup") => {
  try {
    sendOTP(mobile, mode);

    return data;
  } catch (err) {
    throw err;
  }
};

const verifyOtpPass = async (otp) => {
  const data = await verifyOTP(otp, "password");
  return data;
};

const logout = async () => {
  const data = await api.get("/signout");
  return data;
};
export { createUser, loginUser, sendOtpSignup, verifyOtpPass, logout };
